import {HeadingTypography} from "patient-ping-remedy/packages/typography";
import React, {useEffect, useState} from "react";
import DropdownMultiGroupSelect from "patient-ping-remedy/packages/dropdown-multi-group";
import {GenericObject} from "@/hooks/useForm";
import {nonGroupedValues} from "@common/FilterComponent";
import {BorderedContent} from "@/components/pages/settings/event_consumers/EventConsumerForm.styles";
import ADTFilterOptionsForm from "@/components/pages/settings/event_consumers/ADTFilterOptionsForm";
import {EventStatuesMap} from "@/components/pages/settings/event_consumers/EventConsumers.constants";
import {validateIntegerList} from "@/components/pages/settings/event_consumers/EventConsumers.utils";
import ValidatedInput from "@common/ValidatedInput";
import Spacer from "patient-ping-remedy/packages/spacer";
import {sizes} from "patient-ping-remedy/packages/theme";
import InfoIconTooltip from "@common/InfoIconTooltip";
import Helpers from "@/helpers/helpers";

type Props = {
    form: GenericObject,
    handleChange: (event: (React.ChangeEvent | null), name: string, value: any) => void,
    eventType: nonGroupedValues,
    isWithinModal?: boolean
}

const EventDetailFiltersForm = (props: Props) => {
  const [activeCohorts, setActiveCohorts] = useState<string>(
    props.form.filters.value.eventDetailFilters?.[props.eventType.value]?.activeCohorts?.values?.join(", ")
  );

  useEffect(() => {
    if(Helpers.isDefined(activeCohorts)
      && Helpers.isEmpty(validateIntegerList(
        activeCohorts, "Cohorts cannot be empty.", "Group IDs must be integers."
      ))) {
      handleDropdownChange("activeCohorts",
        activeCohorts.split(",")
          .map(cohort => cohort.trim())
          .filter(cohort => cohort && !isNaN(Number(cohort)))
          .map(Number)
      );
    }
  }, [activeCohorts]);

  const handleDropdownChange = (field: string, values: any) => {
    const updated = {
      ...props.form.filters.value,
      eventDetailFilters: {
        ...props.form.filters.value.eventDetailFilters,
        [props.eventType.value]: {
          ...props.form.filters.value.eventDetailFilters?.[props.eventType.value],
          [field]: { values }
        }
      }
    };
    props.handleChange(null, 'filters', updated);
  };

  return (
    <BorderedContent>
      <HeadingTypography>{props.eventType.label}</HeadingTypography>
      <br/><br/><br/>

      <ValidatedInput
        id={`${props.eventType.value.toLowerCase()}-active-cohorts`}
        //@ts-expect-error expects string
        labelText={
          <span>Active cohorts
            <Spacer itemWidth={sizes.xSmall}/>
            <InfoIconTooltip text={"Enter group IDs, separated by commas. Only numeric values are allowed."}/>
          </span>
        }
        value={activeCohorts}
        onChange={(event) => {setActiveCohorts(event.target.value);}}
        validate={(val) => validateIntegerList(
          val, "Cohorts cannot be empty.", "Group IDs must be integers."
        )}
      />

      <DropdownMultiGroupSelect
        id={`${props.eventType.value.toLowerCase()}-event-statuses`}
        label={"Active statuses"}
        options={EventStatuesMap[props.eventType.value]}
        isWithinModal={props.isWithinModal}
        value={EventStatuesMap[props.eventType.value].filter(eventTypes => props.form?.filters?.value?.
          eventDetailFilters?.[props.eventType.value]?.eventStatuses?.values?.includes(eventTypes.value))}
        handleChange={(event) => handleDropdownChange("eventStatuses", event?.map(item => item.value))}
      />

      {props.eventType.value === "ADT" &&
        <ADTFilterOptionsForm
          form={props.form}
          handleChange={props.handleChange}
          isWithinModal={props.isWithinModal}
        />
      }

    </BorderedContent>
  );
};

export default EventDetailFiltersForm;
